export default __webpack_public_path__ + "static/media/cs_icon_06_on.d94e5859.png";